import React from 'react';
import { motion } from 'framer-motion';
const tomos = [{
  icon: '📘',
  title: '01 — Protocolo de Primera Sesión',
  desc: 'La estructura completa de los primeros 60 minutos. Anamnesis, evaluación, diagnóstico kinésico y plan de tratamiento. Nunca más sales de una primera consulta sin saber por dónde empezar.'
}, {
  icon: '📗',
  title: '02 — Vademécum de Pruebas Ortopédicas',
  desc: 'Todos los tests por región con sensibilidad, especificidad y criterios de interpretación. El libro de consulta rápida que necesitas tener siempre a mano.'
}, {
  icon: '📙',
  title: '03 — Traumatología Aguda',
  desc: '15 patologías frecuentes con protocolo completo. Esguince de tobillo, desgarro muscular, tendinopatía, LCA, lumbalgia aguda y más. Con tiempos de recuperación y criterios de alta.'
}, {
  icon: '📔',
  title: '04 — Kine Domiciliaria',
  desc: 'Cómo organizar, equipar y rentabilizar los domicilios. El sistema completo para atender fuera del consultorio sin improvisar.'
}, {
  icon: '📒',
  title: '05 — Agentes Físicos',
  desc: 'Cuándo aplicar TENS, ultrasonido, láser y termoterapia. Y cuándo no. Sin teoría vacía. Con parámetros clínicos concretos.'
}, {
  icon: '📓',
  title: '06 — Informes Profesionales',
  desc: 'Cómo redactar informes que el médico lee y que te diferencian como profesional desde el primer día.'
}, {
  icon: '📘',
  title: '07 — Ejercicio Terapéutico',
  desc: 'Cómo prescribir ejercicio de forma progresiva para cada patología. Con fichas listas para entregar al paciente.'
}, {
  icon: '📗',
  title: '08 — Columna Vertebral',
  desc: 'El mapa clínico completo de lumbar y cervical. Diagnóstico diferencial, banderas rojas, técnicas y protocolos. La región que más tratarás en tu carrera.'
}, {
  icon: '📙',
  title: '09 — Neurología para el Kine',
  desc: 'Parkinson, ACV, esclerosis múltiple y neuropatías periféricas. Las patologías neurológicas que verás en domicilio y para las que nadie te preparó.'
}, {
  icon: '📔',
  title: '10 — Vendaje y Kinesiotaping',
  desc: 'Técnica correcta más criterio clínico para cada aplicación. Cuándo el tape ayuda y cuándo es solo decoración.'
}, {
  icon: '📒',
  title: '11 — El Negocio de la Kine',
  desc: 'Cómo fijar precios, manejar seguros médicos y construir una práctica rentable. Para no trabajar a pérdida sin darte cuenta.'
}, {
  icon: '📓',
  title: '12 — Psicología del Dolor',
  desc: 'Por qué el paciente no mejora aunque hagas todo técnicamente bien. El componente que la facultad ignoró y que define el resultado del tratamiento.'
}, {
  icon: '📘',
  title: '13 — Kine Respiratoria',
  desc: 'EPOC, asma, post-COVID y domicilios respiratorios. Con técnicas, parámetros y criterios de derivación.'
}, {
  icon: '📗',
  title: '14 — Rehabilitación Deportiva',
  desc: 'Retorno al deporte con criterios objetivos. Hop tests, LSI, protocolo de 6 etapas. No a ojo ni por tiempo.'
}, {
  icon: '📙',
  title: '15 — Kine Pediátrica',
  desc: 'Hitos del desarrollo motor, señales de alarma, tortícolis congénita, PC y cómo evaluar un niño sin que llore.'
}, {
  icon: '📔',
  title: '16 — Adulto Mayor',
  desc: 'Evaluación del riesgo de caída, síndrome de fragilidad y el programa de ejercicio con mayor evidencia para prevenir fracturas de cadera.'
}, {
  icon: '📒',
  title: '17 — Terapia Manual',
  desc: 'Movilización articular, manipulación con criterio clínico, neurodinámica y técnicas de tejido blando. Con el razonamiento clínico para saber cuándo aplicar cada técnica.'
}, {
  icon: '📓',
  title: '18 — Kine Obstétrica',
  desc: 'Dolor en el embarazo, preparación para el parto, piso pélvico, diastasis abdominal y rehabilitación de la cicatriz de cesárea.'
}];
export function Tomos() {
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-185">
      <div className="max-w-7xl mx-auto" data-id="element-186">
        <div className="text-center mb-16" data-id="element-187">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-charcoal" data-id="element-188">
            Los 18 tomos del sistema
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-189">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="bg-brand-cream rounded-xl p-6 border border-gray-100 hover:shadow-md transition-shadow" data-id="element-190">
              <div className="text-3xl mb-4" data-id="element-191">{tomo.icon}</div>
              <h4 className="text-lg font-bold text-brand-charcoal mb-3 leading-tight" data-id="element-192">
                {tomo.title}
              </h4>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-193">
                {tomo.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}